export { SkyPageSummaryContentComponent } from './page-summary-content.component';
